import MobileHeroSection from './MobileHeroSection';

export default MobileHeroSection;
